var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"productInner"},[_vm._l((_vm.handlerProduct()),function(item,index){return (index <= 2 )?_c('span',{key:index,staticClass:"inner-content"},[_vm._v(_vm._s(item.name)+"("+_vm._s(item.code)+")")]):_vm._e()}),(_vm.handlerProduct().length > _vm.count)?_c('span',[_vm._v("...")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }